export default __webpack_public_path__ + "static/media/kz.30b07a38.svg";